<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Fecha Registro</th>
                <th :class="StyleTh">Fecha Inicio</th>
                <th :class="StyleTh">Fecha Vencimiento</th>
                <th :class="StyleTh">Timbres Colocados</th>
                <th :class="StyleTh">Timbres Restantes</th>
                <th :class="StyleTh">Estatus</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaRegistro}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaInicio}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaVencimiento}}</p></td>
                    <td><p :class="StyleTd">{{lista.TimbresColocados}}</p></td>
                    <td><p :class="StyleTd">{{lista.TimbresRestantes}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdHistorialTimbres" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="10"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/root/timbradoHistorial/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionTimbradoHistorial';

export default {
    name: 'ListaTimbradoHistorial',
    props: ['pObjEnviado'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Historial Timbres de ',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                ShowTitleFirst: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjSucursal: {},
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("timbradoHistorial",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdSucursal: this.ObjSucursal.IdSucursal,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('timbradoHistorial/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'cuentaSucursal', params:{}});
        },
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objSucursal',JSON.stringify(this.pObjEnviado));
        }

        this.ObjSucursal = JSON.parse(sessionStorage.getItem('objSucursal'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjSucursal.Nombre;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
